import * as React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import {style} from 'typestyle';
import {NestedCSSProperties} from 'typestyle/lib/types';
import {transitionModal, transitionQuickEase} from '../theme/transition';
import {percent, rem, viewHeight, viewWidth} from 'csx';
import {colorBrand, colorSlate, colorWhite} from '../theme/color';
import {centerCenter, content, scrollY, vertical} from 'csstips';
import {zModal} from '../theme/z';
import {shadowNotification} from '../theme/shadow';

export interface ModalProps {
  show: boolean;
  onRequestClose(): void;
  preventClose?: boolean;
}

export class Modal extends React.Component<ModalProps, {}> {
  private content: HTMLDivElement;

  render() {
    const { show, children } = this.props;

    return (
      <ReactCSSTransitionGroup {...transitionModal()}>
        {show && (
          <div className={Modal.styles.container} onClick={this.handleClick}>
            <div className={Modal.styles.content} ref={el => this.content = el}>
              {children}
            </div>
          </div>
        )}
      </ReactCSSTransitionGroup>
    )
  }

  handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!this.content || !this.props.show) return;
    const target = event.target as Node;
    if (this.content !== target && !this.content.contains(target)) {
      event.stopPropagation();
      this.props.onRequestClose();
    }
  };

  componentWillReceiveProps(nextProps: ModalProps) {
    document.body.style.overflow = nextProps.show
      ? 'hidden'
      : 'initial';
  };

  static styles = {
    container: style({
      ...centerCenter,
      zIndex: zModal,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: colorSlate.fade(0.7).toString(),
      transition: `opacity ${transitionQuickEase}`
    }),
    content: style({
      maxWidth: `calc(100vw - 4rem)`,
      maxHeight: `calc(100vh - 4rem)`,
      ...scrollY,
    }),
  }
}

export const ModalChildStyle: NestedCSSProperties = {
  ...vertical,
  ...content,
  ...scrollY,
  maxWidth: percent(100),
  maxHeight: percent(100),
  background: colorWhite.toString(),
  boxShadow: shadowNotification,
  borderRadius: rem(1),
  margin: 0,
  padding: rem(2),
  $nest: {
    '&> h3': {
      color: colorBrand.toString(),
      fontSize: rem(1.75),
      margin: '0 0 1.75rem 0',
      width: percent(100),
    },
  }
};